"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToHeroProps({ data, mappers, inHero, packages, forms }) {
    let image = null;
    if (data.desktopMedia?.length) {
        image = mappers.mapBlock({
            block: data.desktopMedia?.[0],
            mappers,
            inHero,
        });
    }
    let backgroundImage = null;
    if (data.backgroundImage?.length) {
        backgroundImage = mappers.mapBlock({
            block: data.backgroundImage?.[0],
            mappers,
            inHero,
        });
    }
    let mobileImage = null;
    if (data.mobileMedia?.length) {
        mobileImage = mappers.mapBlock({
            block: data.mobileMedia?.[0],
            mappers,
            inHero,
        });
    }
    let mobileBackgroundImage = null;
    if (data.mobileBackgroundImage?.length) {
        mobileBackgroundImage = mappers.mapBlock({
            block: data.mobileBackgroundImage?.[0],
            mappers,
            inHero,
        });
    }
    return {
        id: data.id,
        variant: 'full',
        image,
        backgroundImage,
        mobileImage,
        mobileBackgroundImage,
        alignMainContent: data.alignMainContent?.toLowerCase(),
        alignImageToBottom: data.alignImageToBottom,
        alignMobileImageToBottom: data.alignMobileImageToBottom,
        backgroundColor: data.backgroundColor,
        textColor: data.textColor,
        mobileTextColor: data.mobileTextColor,
        topPadding: data.topPadding,
        bottomPadding: data.bottomPadding,
        jumplink: data.jumpLinkId,
        width: data.width,
        modules: data.modules,
        mainContent: data.mainContent && mappers.mapRichText({
            richText: data.mainContent,
            mappers,
            inHero,
            packages,
            forms,
        }),
    };
}
exports.default = mapToHeroProps;
